import { ColDef } from "ag-grid-community";

export const issueTableColumnTypes = {
  alwaysHidden: {
    hide: true,
    suppressColumnsToolPanel: true,
    suppressFiltersToolPanel: true,
  },
};

export const defaultIssueTableColDef: ColDef = {
  sortable: true,
  minWidth: 100,
  suppressMovable: false,
  resizable: true,
  suppressHeaderMenuButton: true,
  editable: false,
  cellClass: "p-1",
  headerClass: "px-2 py-1",
  cellStyle: {
    whiteSpace: "normal",
    lineHeight: "1.5",
    wordBreak: "break-word",
  },
};

export const ISSUE_TABLE_ROW_HEIGHT = 55;
export const ISSUE_TABLE_HEADER_HEIGHT = 40;
export const ISSUE_TABLE_PAGE_SIZE = 500;
export const ISSUE_TABLE_PAGE_SIZE_OPTIONS = [500, 1000];
export const ISSUE_TABLE_ROW_BUFFER = 20;
